import { useState } from "react";
import moment from "moment";

export const sizePerPageList = [
  {
    text: "10",
    value: 10,
  },
  {
    text: "20",
    value: 20,
  },
  {
    text: "30",
    value: 30,
  },
  {
    text: "40",
    value: 40,
  },
  {
    text: "50",
    value: 50,
  },
];

export const formatDate = (stringDate) => {
  if (stringDate === "1900-01-01T00:00:00Z") {
    return "";
  } else if (stringDate === "0001-01-01T00:00:00Z") {
    return "";
  } else if (stringDate === "0001-01-01") {
    return "";
  } else if (stringDate === null) {
    return "";
  } else {
    return moment(stringDate).format("DD/MM/YYYY");
  }
};

export const formatDateTime = (stringDate) => {
  if (stringDate === "1900-01-01T00:00:00Z") {
    return "";
  } else if (stringDate === "0001-01-01T00:00:00Z") {
    return "";
  } else if (stringDate === "0001-01-01") {
    return "";
  } else if (stringDate === null) {
    return "";
  } else {
    return moment(stringDate).format("DD/MM/YYYY - HH:mm");
  }
};

export const formatDateTimeUtc = (stringDate) => {
  const parsedTime = moment.utc(stringDate).format("DD/MM/YYYY - HH:mm");

  if (stringDate === "1900-01-01T00:00:00Z") {
    return "";
  } else if (stringDate === "0001-01-01T00:00:00Z") {
    return "";
  } else if (stringDate === "0001-01-01") {
    return "";
  } else if (stringDate === null) {
    return "";
  } else {
    return moment(parsedTime, "DD/MM/YYYY - HH:mm")
      .utcOffset("+07:00")
      .format("DD/MM/YYYY - HH:mm");
  }
};

export const formatDatePost = (stringDate) => {
  if (stringDate === "1900-01-01T00:00:00Z") {
    return "";
  } else if (stringDate === "0001-01-01T00:00:00Z") {
    return "";
  } else if (stringDate === "0001-01-01") {
    return "";
  } else if (stringDate === null) {
    return "";
  } else if (stringDate === "") {
    return "";
  } else {
    return moment(stringDate).format("YYYY-MM-DD");
  }
};

export const useForceUpdate = () => {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
};

export const checkRoles = (userRoles, allowedRoles) => {
  return userRoles.some((e) => allowedRoles.includes(e));
};

export const getValueOptions = (value, options) => {
  const return_value = options.filter((val) => value === val.value);
  return return_value;
};

export let currentDate = new Date();
export let year = currentDate.getFullYear();
export let month = currentDate.getMonth() + 1;
export let day = currentDate.getDate();
export let hours = currentDate.getHours();
export let minutes = currentDate.getMinutes();
export let seconds = currentDate.getSeconds();

// Menambahkan nol di depan angka bulan jika kurang dari 10
if (month < 10) {
  month = "0" + month;
}

// Menambahkan nol di depan angka hari jika kurang dari 10
if (day < 10) {
  day = "0" + day;
}

// Menambahkan nol di depan angka jam jika kurang dari 10
if (hours < 10) {
  hours = "0" + hours;
}

// Menambahkan nol di depan angka menit jika kurang dari 10
if (minutes < 10) {
  minutes = "0" + minutes;
}

// Menambahkan nol di depan angka detik jika kurang dari 10
if (seconds < 10) {
  seconds = "0" + seconds;
}

export const defaultDate = year + "-" + month + "-" + day;

export const normalizeDate = (dateStr) => {
  const d = new Date(dateStr);
  return d.toISOString().split("T")[0]; // ambil hanya YYYY-MM-DD
};

export const isAfterOrEqual = (date1, date2) => {
  return normalizeDate(date1) >= normalizeDate(date2);
};
